module.exports = __webpack_public_path__ + "static/media/16-3.a1af20c5.mp3";